<script lang="ts">import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const XIcon = getIcon("XIcon");
</script>

{#if typeof XIcon === 'string'}
	<img src={XIcon} alt={$t(Verbiage.x_icon_alt, 'alts')} />
{:else if typeof XIcon === 'function'}
	<svelte:component this={XIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
